import React from 'react'
import style from "css/address.module.css";

function GroupTag({ tag }) {
    // console.log("tag : ", tag)
    return (
        <div
            className={style.addr_tag_wrapper}
            style={{
                color: tag.txt_color,
                backgroundColor: tag.bg_color
            }}
        >{tag.label}</div>
    )
}

export default GroupTag
